import { JSX } from "react";
import { DstProductDetailAttribute } from "../../interfaces/ProductDetailViewTypes";

interface Props {
    attribute: DstProductDetailAttribute;
}

export const ProductSpecificationAttributeValue = ({
    attribute,
}: Props): JSX.Element => {
    if (attribute.is_bullet_points && attribute.items.length > 0) {
        return (
            <ul>
                {attribute.items.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        );
    }

    return <span>{attribute.value}</span>;
};
